const router = [
	// 用户管理
	{
		path: '/userAdmin',
		component: () => import('../views/userAdmin/index.vue'),
		children: [
			// 用户列表
			{
				path: 'userList',
				component: () => import('../views/userAdmin/userList.vue')
			},
			{
				path: '/userAdmin',
				redirect: '/userAdmin/userList'
			},
			// 管理员列表

			{
				path: 'adminList',
				component: () => import('../views/userAdmin/adminList.vue')
			},

			//部门管理
			{
				path: 'classList',
				component: () => import('../views/userAdmin/classList.vue')
			},

			// 咨询师列表
			{
				path: 'counselorList',
				component: () => import('../views/counselorConsult/counselorList.vue')
			},

		]
	},
	// 专家咨询
	{
		path: '/counselorConsult',
		component: () => import('../views/counselorConsult/index.vue'),
		redirect: '/counselorConsult/jumpToMiddlePage',
		children: [
			{
				path: 'jumpToMiddlePage',
				component: () => import('../views/counselorConsult/jumpToMiddlePage.vue')
			},

			
			// 我要咨询预约
			{
				path: "consult",
				component: () => import('../views/counselorConsult/consult')
			},

			// 咨询记录
			{
				path: 'consultRecord',
				component: () => import('../views/counselorConsult/consultRecord.vue')
			},
			// 咨询历史记录管理员
			{
				path: 'consultAppointRecord',
				component: () => import('../views/counselorConsult/consultAppointRecord.vue')
			},
			//工作排期
			{
				path: 'schedule',
				component: () => import('../views/counselorConsult/schedule.vue')
			}
		]
	},
	// 录入测评结果
	{
		path: '/enteringAppraisalResult',
		component: () => import('../views/enteringAppraisalResult/index.vue'),
		children: [
			{
				path: 'enteringAppraisalResult',
				component: () => import('../views/enteringAppraisalResult/enteringAppraisalResult.vue')
			},

			{
				redirect: '/enteringAppraisalResult/enteringAppraisalResult',
				path: '/enteringAppraisalResult'
			}
		]
	},
	// 互动测评
	{
		path: '/interaction',
		component: () => import('../views/interaction/index.vue'),
		redirect: '/interaction/interaction',
		children: [
			{
				// 互动测评
				path: 'interaction',
				component: () => import('../views/interaction/interaction.vue')
			},
			// 设置答题器
			{
				path: 'setAnswerTool',
				component: () => import('../views/interaction/setAnswerTool.vue')
			},
			// 使用帮助
			{
				path: 'help',
				component: () => import('../views/interaction/help.vue')
			},
			// 互动测评结果
			{
				path: 'interactionAppraisalResult',
				component: () => import('../views/interaction/interactionAppraisalResult.vue')
			},

		]

	},
	// 测评开始
	{
		path: '/evaluation',
		component: () => import('../views/interaction/evaluation.vue')
	},
	// 系统设置
	{
		path: '/setting',
		component: () => import('../views/setting/index.vue'),

		children: [
			{
				path: '/setting',
				redirect: '/setting/companySynopsis'
			},
			{
				// 公司简介
				path: 'companySynopsis',
				component: () => import('../views/setting/companySynopsis.vue')
			}
			,
			// 系统设置
			{
				path: 'systemSetting',
				component: () => import('../views/setting/systemSetting.vue')
			},
			// 资料备份
			{
				path: 'dataBackups',
				component: () => import('../views/setting/dataBackups.vue')
			},
			// 回收站
			{
				path: 'recycleBin',
				component: () => import('../views/setting/recycleBin.vue')
			},
			// 数据同步
			{
				path: 'dataSynchronism',
				component: () => import('../views/setting/dataSynchronism.vue')
			}
		]
	},

	// 心理自助
	// {
	// 	path: '/relax',
	// 	component: () => import('../views/relax/index.vue'),
	// 	redirect: '/relax/music',
	// 	children: [
	// 		{
	// 			// 音乐治疗
	// 			path: 'music',
	// 			component: () => import('../views/relax/music/index.vue')
	// 		},


	// 	]
	// },
];


export default router;